import React from 'react';

export default function ActivityLog() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Activity Log</h1>
      <p className="text-gray-500">Halaman Activity Log</p>
    </div>
  );
}
